import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  BookActionEnum,
  IAssociateBookWithDocIdAction,
  IFetchBookByDocIdsAction,
} from '.';
import { IApplicationState } from '..';
import {
  IBook,
  BookService,
  IDocumentBookCode,
  IUpdateDocumentBookCodeResult,
} from '../../services';
import {
  AssociateBookWithDocIdFailureAction,
  AssociateBookWithDocIdSuccessAction,
  FetchBookFailedAction,
  FetchBookSuccessAction,
  FetchBookWithDocIdByDocIdFailureAction,
  FetchBookWithDocIdByDocIdSuccessAction,
} from './ActionCreator';

const bookService = new BookService();

export const fetchBooksEpic = (action$: any) =>
  action$.pipe(
    ofType(BookActionEnum.FetchBooks),
    switchMap(() => {
      const books = bookService.getAllBooks();
      return books;
    }),
    map((response: IBook[]) => {
      return FetchBookSuccessAction(response);
    }),
    catchError((x) => {
      console.error(x);
      return of(FetchBookFailedAction());
    })
  );

export const fetchBookAndDocIdEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(BookActionEnum.FetchBookWithDocIdsByDocIds),
    withLatestFrom(state$),
    switchMap(
      ([action, state]: [IFetchBookByDocIdsAction, IApplicationState]) => {
        if (action?.state?.bookAndDocId) {
          const bookAndDocIds = bookService.getBookAndDocIdByDocId(
            action?.state?.bookAndDocId.docId
          );
          return bookAndDocIds;
        } else {
          console.log('Null BookAndDocIds');
          return of(
            FetchBookWithDocIdByDocIdFailureAction(
              'Could not set Document Book Code before fetching from the API. Pleae contact IT Support'
            )
          );
        }
      }
    ),
    map((response: IDocumentBookCode) => {
      return FetchBookWithDocIdByDocIdSuccessAction(response);
    }),
    catchError((x) => {
      console.error(x);
      return of(
        FetchBookWithDocIdByDocIdFailureAction(
          'Error in Fetching Book WithDocId. Please contact IT Support.'
        )
      );
    })
  );

export const associateBookWithDocIdEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(BookActionEnum.AssociateBookWithDocId),
    withLatestFrom(state$),
    switchMap(
      ([action, state]: [IAssociateBookWithDocIdAction, IApplicationState]) => {
        if (action?.state?.bookAndDocId) {
          const responseMessage = bookService.associateBookWithDocId(
            action.state?.bookAndDocId
          );
          return responseMessage;
        } else {
          return of(
            AssociateBookWithDocIdFailureAction('BookAndDocId is null')
          );
        }
      }
    ),
    map((response: IUpdateDocumentBookCodeResult) => {
      return AssociateBookWithDocIdSuccessAction(response);
    }),
    catchError((x) => {
      console.error(x);
      return of(
        AssociateBookWithDocIdFailureAction(
          'Unable to associate Book With Auction. Please contact IT support.'
        )
      );
    })
  );
